import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Shield } from "lucide-react";
import ServicesData from "../pages/services/ServicesData";
import OptimizedImg from "./OptimizedImg";

const ProductsData = [
  { name: "Rent & Property Management", slug: "rent-property-management-solution" },
  { name: "Medical Equipment Management", slug: "hospital-equipment-management" },
  { name: "Printing Management System", slug: "printing-management-system" },
  { name: "Electrical Panel Management", slug: "electrical-panel-management" },
  { name: "Sagveek Learning Management", slug: "learning-management-system" },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null); // "services" | "products"

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const handleNavClick = () => {
    setMenuOpen(false);
    setActiveSubmenu(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleSubmenu = (menuName) => {
    setActiveSubmenu((prev) => (prev === menuName ? null : menuName));
  };

  return (
    <>
      <style>{`
        .nav-wrap{
          width:100%;
          display:flex;
          align-items:center;
          justify-content:space-between;
          padding:0 25px;
          height:70px;
          background:#faf8ff;
          box-shadow:0 2px 10px rgba(124,58,237,0.08);
          border-bottom: 1px solid rgba(124,58,237,0.1);
          position: sticky;
          top: 0;
          z-index: 9999;
        }

        .logo-left picture{
          display:block;
        }
        .logo-left img{
          height:130px;
          width:260px;
          margin-top:-10px;
          object-fit:contain;
        }

        .menu-toggle{
          display:none;
          font-size:28px;
          cursor:pointer;
          color:#5b21b6;
        }

        #mainmenu{
          display:flex;
          align-items:center;
          margin:0;
          padding:0;
          list-style:none;
          gap:22px;
          font-weight:500;
          font-family:'Inter', sans-serif;
        }

        #mainmenu > li{
          position:relative;
        }

        #mainmenu > li > a{
          padding:6px 10px;
          color:#1f2937;
          text-decoration:none;
          font-weight:700;
          display:flex;
          align-items:center;
          justify-content:space-between;
          transition: color 0.25s ease;
        }

        #mainmenu > li > a:hover,
        .arrow{margin-left:6px; font-size:22px; color:#5b21b6;}

        .nav-right-actions {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .nav-admin-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
          color: #ffffff !important;
          font-size: 13px;
          font-weight: 700;
          padding: 7px 15px;
          border-radius: 8px;
          text-decoration: none !important;
          box-shadow: 0 2px 8px rgba(124, 58, 237, 0.25);
          transition: all 0.25s ease;
          white-space: nowrap;
        }

        .nav-admin-btn:hover {
          background: linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%);
          box-shadow: 0 4px 14px rgba(124, 58, 237, 0.4);
          transform: translateY(-1px);
          color: #ffffff !important;
        }

        .nav-admin-btn:active {
          transform: translateY(0);
        }

        /* MOBILE STYLES */
        @media(max-width:992px){
          .menu-toggle{ display:block; }

          #mainmenu{
            position:fixed;
            top:0;
            right:0;
            height:100%;
            width:70%;
            max-width:400px;
            background:#faf8ff;
            flex-direction:column;
            align-items:flex-start;
            gap:0;
            padding:20px;
            box-shadow:-2px 0 20px rgba(124,58,237,0.15);
            transform: translateX(100%);
            transition: transform 0.3s ease;
            z-index: 10000;
            overflow-y: auto; /* scrollable menu */
            -webkit-overflow-scrolling: touch; /* smooth scroll iOS */
          }

          #mainmenu.show{transform: translateX(0);}

          #mainmenu li{width:100%;}

          #mainmenu li ul{
            position:static;
            display:none;
            width:100%;
            padding-left:15px;
            max-height:300px; /* scrollable submenu */
            overflow-y:auto;
            box-shadow:none;
            font-weight:700;
          }

          #mainmenu li ul.show-sub{display:block;}

          .close-btn{
            font-size:28px;
            cursor:pointer;
            align-self:flex-end;
            margin-bottom:20px;
            color:#5b21b6;
          }

          .overlay{
            position:fixed;
            top:0;
            left:0;
            width:100%;
            height:100%;
            background:rgba(20,10,40,0.35);
            z-index:9999;
          }

          #mainmenu li a, #mainmenu li div.menu-item{
            width:100%;
          }
        }

        /* DESKTOP SUBMENU SCROLL */
        @media(min-width:993px){
        /* HIDE arrow on desktop */
            @media(min-width:993px){
              .arrow {
                display: none;
              }
            }

          .close-btn{display:none;}

          #mainmenu > li > ul {
            position: absolute;
            top: 100%;
            left: 0;
            background: #fff;
            min-width: 200px;   /* adjust as needed */
            max-height: 300px;  /* scrollable height */
            overflow-y: auto;   /* enable scroll */
            box-shadow: 0 12px 28px rgba(124,58,237,0.14);
            border: 1px solid rgba(124,58,237,0.15);
            border-radius: 8px;
            display: none;      /* hidden by default */
            z-index: 1000;
            overflow: hidden;
          }

          /* Show submenu on hover */
          #mainmenu > li:hover > ul {
            display: block;
          }

          #mainmenu > li > ul li {
            width: 100%;
          }

          #mainmenu > li > ul li a {
            padding: 8px 12px;
            display: block;
            font-weight: 500;
            color: #1f2937;
            text-decoration:none;
            transition: background 0.2s ease, color 0.2s ease;
          }

          #mainmenu > li > ul li a:hover {
            background: rgba(124,58,237,0.08);
            color: #7c3aed;
          }
        }
      `}</style>

      <div className="nav-wrap">
        <div className="logo-left">
          <Link to="/" onClick={handleNavClick}>
            <OptimizedImg src="/images/sn_logo.png" alt="Logo" width={260} height={130} loading="eager" fetchPriority="high" avif={false} />
          </Link>
        </div>

        {/* Overlay */}
        {menuOpen && <div className="overlay" onClick={() => setMenuOpen(false)}></div>}

        <ul id="mainmenu" className={menuOpen ? "show" : ""}>
          {/* Close button for mobile */}
          <div className="close-btn" onClick={() => setMenuOpen(false)}>×</div>

          <li><NavLink to="/" onClick={handleNavClick}>Home</NavLink></li>
          <li><NavLink to="/about" onClick={handleNavClick}>About</NavLink></li>

          {/* SERVICES */}
          <li>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems:"center", width:"100%" }}>
              <NavLink
                to="/services"
                onClick={handleNavClick}
                style={{ padding:"6px 10px", color:"#1f2937", flex:1, fontWeight:700 }}
              >
                Services
              </NavLink>
              <div onClick={() => toggleSubmenu("services")} style={{ padding:"6px 10px", cursor:"pointer" }}>
                <span className="arrow">{activeSubmenu === "services" ? "▴" : "▾"}</span>
              </div>
            </div>
            <ul className={activeSubmenu === "services" ? "show-sub" : ""}>
              {ServicesData.map((s, i) => (
                <li key={i}>
                  {s.slug === "edtech-solutions" ? (
                    <a href="/courses" target="_blank" rel="noopener noreferrer" onClick={handleNavClick}>
                      {s.name}
                    </a>
                  ) : (
                    <NavLink to={`/services/${s.slug}`} onClick={handleNavClick}>
                      {s.name}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </li>

          {/* PRODUCTS */}
          <li>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems:"center", width:"100%" }}>
              <NavLink
                to="/products"
                onClick={handleNavClick}
                style={{ padding:"6px 10px", color:"#1f2937", flex:1, fontWeight:700 }}
              >
                Products
              </NavLink>
              <div onClick={() => toggleSubmenu("products")} style={{ padding:"6px 10px", cursor:"pointer" }}>
                <span className="arrow">{activeSubmenu === "products" ? "▴" : "▾"}</span>
              </div>
            </div>
            <ul className={activeSubmenu === "products" ? "show-sub" : ""}>
              {ProductsData.map((p, i) => (
                <li key={i}>
                  <NavLink to={`/products/${p.slug}`} onClick={handleNavClick}>
                    {p.name}
                  </NavLink>
                </li>
              ))}
              <li>
                <NavLink to="/products" onClick={handleNavClick}>
                  View All Products
                </NavLink>
              </li>
            </ul>
          </li>

          <li><NavLink to="/careers" onClick={handleNavClick}>Careers</NavLink></li>
          <li><NavLink to="/faqs" onClick={handleNavClick}>FAQ</NavLink></li>
          <li><NavLink to="/contact-us" onClick={handleNavClick}>Contact</NavLink></li>
        </ul>

        {/* Top Right Navbar Actions */}
        <div className="nav-right-actions">
          <Link
            to="/admin"
            className="nav-admin-btn"
            onClick={handleNavClick}
            title="Admin Login"
          >
            <Shield size={14} />
            <span>Admin Login</span>
          </Link>

          <div className="menu-toggle" onClick={() => setMenuOpen(true)}>☰</div>
        </div>
      </div>
    </>
  );
};

export default Navbar;